import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from 'config'
import { Row, Col } from 'react-flexbox-grid'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Link,
  LinkIcon
} from '../../components'
import Styles from './IssuePage.css'

@CSSModules(Styles, {allowMultiple:true})
export default class IssueDeforestation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: 'The issue: Deforestation',
      description: 'Clearing rain forests for cattle grazing or palm oil production contributes to the climate crisis and threatens the rights of Indigenous peoples, traditional landowners, and local communities.',
      url: config.domain + config.routes.issueDeforestation
    }
  }

  render() {
    return (
      <div styleName='page issue-dff'>
        {
          container.helmet(
            this.state.title,
            this.state.description,
            this.state.url
          )
        }
        <ContainerDivs>
          <section styleName='section'>
            <h1 styleName='issue-top-label'>
              The issue: <span>Deforestation</span>
            </h1>
            <h2 styleName='issue-top-headline'>
              The destruction of forests is a disaster for climate, biodiversity, and human rights
            </h2>
            <h3 styleName='issue-top-copy'>
              Clearing rain forests for cattle grazing or palm oil production contributes to the climate crisis and threatens the rights of Indigenous peoples, traditional landowners, and local communities.
            </h3>
          </section>
          <section styleName='section'>
            <Row>
              <Col xs={12} md={4}>
                <div styleName='issue-second-headline'>
                  <span style={{whiteSpace: 'nowrap'}}>&mdash;&mdash;&mdash;&mdash;</span>
                  <br/>
                  <h2>Retirement plans are invested in deforestation</h2>
                </div>
              </Col>
              <Col xs={12} md={8}>
                <div styleName='issue-second-copy'>
                  <p>
                    From the Amazon to Borneo to the boreal forests of Northern Alberta, asset managers consistently invest in industries that are cutting and burning down our rainforests. This releases carbon, removes carbon sinks, and threatens endangered plants and animal species with extinction.
                  </p>
                  <p>
                    Through displacement, land grabs, and violence, the agribusiness industry driving this deforestation also threatens the rights of Indigenous peoples and local communities who oppose deforestation.
                  </p>
                  <p>
                    Through funds from asset managers like Vanguard, BlackRock, and State Street, corporate retirement plans have hundreds of millions of dollars invested in agricultural commodity producers and traders that have a past record or a significant risk of contributing to deforestation, land grabbing, and human rights abuses.
                  </p>
                </div>
              </Col>
            </Row>
          </section>
          <section styleName='section'>
            <Row>
              <Col xs={12} md={6}>
                <div styleName='img-issue'/>
              </Col>
              <Col xs={12} md={6}>
                <div>
                  <h2 styleName='issue-focus-label'>
                    FOCUS: SUSTAINABILITY RISK
                  </h2>
                  <h3 styleName='issue-focus-headline'>
                    Agricultural commodity producers and traders
                  </h3>
                  <div styleName='issue-focus-copy'>
                    <p>
                      Companies that produce and trade palm oil, paper/pulp, rubber, timber, cattle, and soy have a high risk of deforestation being tied to their supply chains.
                    </p>
                    <p>
                      Different industries impact different forests. For example, deforestation in the Amazon often begins with land speculators illegally clearing and burning large areas of forests and then selling this land to ranchers for the production of beef and soy, which is then sold to Archer-Daniels Midland, JBS, and other global traders.
                    </p>
                    <p>
                      <Link
                        to={config.routes.companies + '#deforestation'}
                        title='Companies: Deforestation'
                        xstrong
                      >
                        Learn more<LinkIcon />
                      </Link>
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </section>
        </ContainerDivs>
        <div styleName='section-solutions-faq-background'>
          <ContainerDivs>
            <section styleName='section section-solutions-faq'>
              <Row>
                <Col xs={12} md={6}>
                  <div styleName='section-solutions-faq-cell'>
                    <h2 styleName='issue-solutions-label'>
                      The Solutions
                    </h2>
                    <h3 styleName='issue-solutions-headline'>
                      Exclude deforestation-driving companies from retirement plan default options
                    </h3>
                    <div styleName='issue-solutions-copy'>
                      <p>
                        The default option offered in company retirement plans, which usually ends up with the bulk of employee contributions, should be sustainably invested and exclude deforestation commodity companies if they lack clear policies with safeguards in place to ensure that their products are not being sourced from deforested lands.
                      </p>
                    </div>
                    <div styleName='issue-faqs-link'>
                      <Link
                        to={config.routes.solutionDefaultSustainability}
                        title='Solution: Default to sustainability'
                        xstrong
                      >
                        Explore solutions<LinkIcon/>
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={6}>
                  <div styleName='section-solutions-faq-cell'>
                    <h2 styleName='issue-faqs-label'>
                      FAQs
                    </h2>
                    <div styleName='issue-faqs-headline'>
                      Answers to common questions about how retirement plans and asset managers are financing deforestation and the climate crisis.
                    </div>
                    <div styleName='issue-faqs-item'>
                      <Link
                        to={config.routes.faqs + '#do-i-have-to-sacrifice-returns-in-order-to-invest-sustainably-'}
                        title='Do I have to sacrifice returns in order to invest sustainably?'
                        xstrong
                      >
                        Do I have to sacrifice returns in order to invest sustainably?
                      </Link>
                    </div>
                    <div styleName='issue-faqs-item'>
                      <Link
                        to={config.routes.faqs + '#why-should-retirement-plans-add-a-sustainable-investment-option-'}
                        title='Why should retirement plans add a sustainable investment option?'
                        xstrong
                      >
                        Why should retirement plans add a sustainable investment option?
                      </Link>
                    </div>

                    <div styleName='issue-faqs-link'>
                      <Link
                        to={config.routes.faqs}
                        title='FAQs'
                        xstrong
                      >
                      View all >>
                      </Link>
                    </div>
                  </div>
                </Col>
              </Row>
            </section>
            <br/>
            <br/>
          </ContainerDivs>
        </div>
      </div>
    )
  }
}
